<template>
  <pageHeader :pageName="this.$store.getters.getWordLocale('txt_urun_detay')" />

  <ForieLoader
    class="bg-trans"
    v-show="showLoader && this.$store.state.domainSystemX == 1"
  />
  <TeLoader
    class="bg-trans"
    v-show="showLoader && this.$store.state.domainSystemX == 2"
  />

  <div class="container" v-show="showLoader == false">
    <div class="d-flex justify-content-between company-detail-title-box">
      <h2>{{ companyName }}</h2>

      <div class="did-floating-label-content">
        <select
          @change="changeLanguage($event.target.value.toLowerCase())"
          class="did-floating-select form-control"
        >
          <option value="">
            {{
              this.$store.state.languagesNamesX.filter(
                (q) => q.code == this.$store.state.langCodeX
              )[0].name
            }}
          </option>
          <option
            v-for="(language, index) in this.$store.state.domainLanguages"
            :key="index"
            v-show="language.LangCode != this.$store.state.langCodeX"
            :value="language.LangCode"
          >
            {{
              this.$store.state.languagesNamesX.filter(
                (q) => q.code == language.LangCode
              )[0].name
            }}
          </option>
        </select>
        <label class="did-floating-label">{{
          this.$store.getters.getWordLocale("txt_dili_degistir")
        }}</label>
      </div>
    </div>
    <div style="">
      <div class="d-flex membership-package-description">
        <a
          ><img :src="memebrshipIcon" /><span>{{ membershipName }}</span></a
        >
        <a v-show="isVip">
          <img :src="require(`/src/assets/img/VIP.svg`)" />
          <span>{{ this.$store.getters.getWordLocale("txt_vip_uye") }}</span></a
        >
        <a v-show="years != ''">
          <img :src="require(`/src/assets/img/Years.svg`)" /><span
            >{{ years }}
            {{ this.$store.getters.getWordLocale("txt_yil") }}</span
          ></a
        >
      </div>
    </div>

    <div class="back-to-company-details-box">
      <router-link
        :to="
          '/' +
          this.$store.state.langCodeX +
          '/company/' +
          companyUrlName +
          '-' +
          companyId
        "
      >
        <i class="material-icons-outlined"> keyboard_arrow_left </i>
        <span>{{
          this.$store.getters.getWordLocale("txt_firmaya_geri_don")
        }}</span></router-link
      >
    </div>

    <div v-if="showLoader == false" class="product-detail-first-image-box">
      <abbr class="zoom-btn" v-on:click="zoomClosestImage"
        ><i class="material-icons-outlined"> zoom_in </i>
        <span>Zoom</span></abbr
      >
      <lightgallery
        :settings="{ speed: 500, plugins: plugins }"
        :onInit="onInit"
        :onBeforeSlide="onBeforeSlide"
      >
        <a
          v-for="(product, pIndx) in companyProducts"
          :key="pIndx"
          class="gallery-item first-gallery"
          :data-src="'https://cdn.turkishexporter.com.tr' + product.image"
          :data-sub-html="'<h4>' + product.fullTitle + '</h4>'"
        >
          <img
            v-bind:class="{ 'img-responsive': true, gFirstImage: pIndx == 0 }"
            :src="'https://cdn.turkishexporter.com.tr' + product.image"
          />
        </a>
      </lightgallery>
      <span class="first-product-item-text">{{ productName }}</span>
    </div>
    <div class="other-photos-box">
      <div class="other-photos-title">
        <i class="material-icons-outlined"> image </i>

        <span>{{
          this.$store.getters.getWordLocale("txt_diger_resimler")
        }}</span>
      </div>

      <div class="d-flex flex-wrap other-product-images-list">
        <router-link
          v-for="(product, pIndx) in companyProducts"
          :to="
            '/' +
            this.$store.state.langCodeX +
            '/' +
            product.productLink +
            '/' +
            companyUrlName.split(`-`).slice(0, 3).join(`-`) +
            '-' +
            companyId +
            '/' +
            companyCountry.toLowerCase().split(' ')[0] +
            '/export-products'
          "
          v-on:click="changeProductView(product.id)"
          :key="pIndx"
          class="other-product-images-item d-flex flex-wrap"
        >
          <img
            class="img-responsive"
            :src="'https://cdn.turkishexporter.com.tr' + product.image"
          />

          <span :title="product.fullTitle">{{ product.title }}</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Lightgallery from "lightgallery/vue";
import lgZoom from "lightgallery/plugins/zoom";
import lgVideo from "lightgallery/plugins/video";
import pageHeader from "./Components/Thema4PageHeader.vue";
import helper from "./helper.js";
import moment from "moment";
import ForieLoader from "../shared/ForieLoader.vue";
import TeLoader from "../shared/TeLoader.vue";

export default {
  data() {
    return {
      plugins: [lgZoom, lgVideo],
      companyName: "",
      memebrshipIcon: "",
      membershipName: "",
      years: "",
      showLoader: true,
      companyDetails: [],
      productName: "",
      productId: 0,
      companyProducts: [],
      companyDetailsUrl: "",
      companyFirst3Words: "",
    };
  },
  components: {
    ForieLoader,
    TeLoader,
    pageHeader,
    Lightgallery,
  },
  methods: {
    zoomClosestImage() {
      helper.zoomImage();
    },
    changeProductView(id) {
      this.showLoader = true;
      var temp = [];
      var index = 1;
      var lastIndexBeforeTarget = 0;
      this.companyProducts.forEach((ele) => {
        if (ele.id == id) {
          index = 0;
          this.productName = ele.fullTitle;
        }

        temp.push({
          index: index,
          id: ele.id,
          image: ele.image,
          title: ele.title,
          fullTitle: ele.fullTitle,
          description: ele.description,
          productLink: ele.productLink,
        });

        if (index == 0) {
          index = lastIndexBeforeTarget + 1;
        } else {
          index++;
        }
      });

      temp = temp.sort((a, b) =>
        a.index > b.index ? 1 : b.index > a.index ? -1 : 0
      );

      this.companyProducts = [];
      this.companyProducts = temp;

      window.scrollTo(0, 0);
      setTimeout(() => {
        this.showLoader = false;
        this.$store.state.detailsTitleX =
          `${this.productName} ${this.companyFirst3Words}`.substr(0, 70);
        this.$store.state.detailsDescriptionX = `${this.productName} ${this.companyName} ${this.companyCountry}`;
      }, 250);
    },
    changeLanguage(langCode) {
      this.$store.state.langCodeX = langCode;
    },
    async getCompany() {
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCompany`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            companyId: parseInt(this.companyId),
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (this.companyDetails = data))
        .catch((err) => console.log(err.message));

      if (this.companyDetails == null) {
        window.location.href = `/${this.$store.state.langCodeX}/not-found`;
      }

      const dateObject = new Date(this.companyDetails.CreateTime);

      var endDate = moment(new Date(), "YYYY");
      var createTime = moment(String(dateObject)).format("YYYY");

      var diff = endDate.diff(createTime, "years");
      if (diff != undefined && !isNaN(diff) && diff > 0) {
        this.years = diff;
      }

      this.companyName =
        this.companyDetails.Localizations.filter(
          (q) => q.LangCode == this.$store.state.langCodeX
        ).length > 0
          ? this.companyDetails.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            )[0].Name
          : this.companyDetails.Localizations.filter(
              (q) => q.LangCode != this.$store.state.langCodeX
            )[0].Name;

      this.companyUrlName = `${this.companyName
        .toLowerCase()
        .trim()
        .split(" ")
        .join("-")}`;

      this.companyUrlName = this.companyUrlName.replace(/[^a-zA-Z0-9,-]/g, "");
      this.companyUrlName = this.companyUrlName.replace(/---/g, "-");
      this.companyUrlName = this.companyUrlName.replace(/--/g, "-");

      this.companyCountry =
        this.companyDetails.Country.filter(
          (q) => q.LangCode == this.$store.state.langCodeX
        ).length > 0
          ? this.companyDetails.Country.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            )[0].Name
          : this.companyDetails.Country.filter(
              (q) => q.LangCode != this.$store.state.langCodeX
            )[0].Name;

      this.companyFirst3Words = this.companyName
        .split(" ")
        .slice(0, 3)
        .join(" ");

      this.$store.state.detailsTitleX =
        `${this.productName} ${this.companyFirst3Words}`.substr(0, 70);
      this.$store.state.detailsDescriptionX = `${this.productName} ${this.companyName} ${this.companyCountry}`;

      this.isVip = this.companyDetails.IsVip;
      this.getCompanyInformation();
    },
    async getCompanyInformation() {
      var result = [];
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCompanyInformation`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            companyId: parseInt(this.companyId),
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (result = data))
        .catch((err) => console.log(err.message));

      this.buildCompanyInfo(result);
    },
    buildCompanyInfo(variable) {
      this.membershipName =
        variable.CompanyActiveMembership.Localizations.length == 0
          ? ""
          : variable.CompanyActiveMembership.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            ).length > 0
          ? variable.CompanyActiveMembership.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            )[0].Name
          : variable.CompanyActiveMembership.Localizations.filter(
              (q) => q.LangCode != this.$store.state.langCodeX
            )[0].Name;

      this.memebrshipIcon = `https://cdn.turkishexporter.com.tr${variable.CompanyActiveMembership.Icon}`;
      this.getCompanyProducts();
    },
    async getCompanyProducts() {
      var companies = [parseInt(this.companyId)];
      var result = [];
      var index = 1;
      var lastIndexBeforeTarget = 0;
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCompanyProducts`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            companies: companies,
            count: 20,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (result = data))
        .catch((err) => console.log(err.message));

      var temp = [];
      if (result.length > 0) {
        var products = [];
        products = result[0].Products;

        products.forEach((product) => {
          if (product.Images.length > 0) {
            product.Images.forEach((pImage) => {
              var id = parseInt(pImage._id);
              var image = pImage.Image;
              var title =
                product.Localizations.length == 0
                  ? ""
                  : product.Localizations.filter(
                      (q) => q.LangCode == this.$store.state.langCodeX
                    ).length > 0
                  ? product.Localizations.filter(
                      (q) => q.LangCode == this.$store.state.langCodeX
                    )[0].Name
                  : product.Localizations.filter(
                      (q) => q.LangCode != this.$store.state.langCodeX
                    )[0].Name;

              var fullTitle = title;
              title = title.length > 15 ? `${title.substr(0, 15)}...` : title;

              var description =
                product.Localizations.length == 0
                  ? ""
                  : product.Localizations.filter(
                      (q) => q.LangCode == this.$store.state.langCodeX
                    ).length > 0
                  ? product.Localizations.filter(
                      (q) => q.LangCode == this.$store.state.langCodeX
                    )[0].Description
                  : product.Localizations.filter(
                      (q) => q.LangCode != this.$store.state.langCodeX
                    )[0].Description;

              var productLink = `${fullTitle
                .toLowerCase()
                .trim()
                .split(" ")
                .join("-")}-${id}`;

              productLink = productLink.replace(/[^a-zA-Z0-9,-]/g, "");
              productLink = productLink.replace(/---/g, "-");
              productLink = productLink.replace(/--/g, "-");

              if (image != undefined && image != "") {
                if (this.productId == id) {
                  lastIndexBeforeTarget = index;
                  index = 0;
                }

                temp.push({
                  index: index,
                  id: id,
                  image: image,
                  title: title,
                  fullTitle: fullTitle,
                  description: description,
                  productLink: productLink,
                });

                if (index == 0) {
                  index = lastIndexBeforeTarget + 1;
                } else {
                  index++;
                }
              }
            });
          }
        });

        temp = temp.sort((a, b) =>
          a.index > b.index ? 1 : b.index > a.index ? -1 : 0
        );

        this.companyProducts = [];
        this.companyProducts = temp;
        this.showLoader = false;
      }
    },
    onInit: () => {
      console.log("lightGallery has been initialized");
    },
    onBeforeSlide: () => {
      console.log("calling before slide");
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.companyId = helper.getCompanyId(this.$route.params.companyName);
    this.productName = helper.getProductName(this.$route.params.id);
    this.productId = helper.getCompanyId(this.$route.params.id);
    this.companyDetailsUrl = this.$route.params.companyName;
    this.getCompany();
  },
};
</script>

<style lang="css">
@import url("https://cdn.jsdelivr.net/npm/lightgallery@2.0.0-beta.4/css/lightgallery.css");
@import url("https://cdn.jsdelivr.net/npm/lightgallery@2.0.0-beta.4/css/lg-zoom.css");
@import url("https://cdn.jsdelivr.net/npm/lightgallery@2.0.0-beta.4/css/lg-video.css");

.other-product-images-item {
  flex-direction: column;
  /* M3/read-only/light/white */
  background: #ffffff;
  /* M3/read-only/light/outline/opacity-0.16 */
  border: 1px solid var(--m3--read-only--light--outline--opacity-016);
  box-sizing: border-box;
  border-radius: 12px;
  overflow: hidden;
  margin-right: 24px;
  margin-bottom: 24px;
  cursor: pointer;
  width: 258px;
  justify-content: space-between;
  background: #fff;
}
.other-product-images-item:nth-child(4n + 0) {
  margin-right: 0;
}
.other-product-images-item > img {
  width: 100%;
}
.other-product-images-item > span {
  /* M3/body/large */
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  letter-spacing: 0.5px;
  /* M3/read-only/light/black */
  color: #000000;
  padding: 16px;
  background: var(--m3--read-only--light--outline--opacity-008);
}
.other-photos-title {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.other-photos-title i {
  margin-right: 10px;
  color: var(--m3--sys--light--primary);
}

.other-photos-title span {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  display: flex;
  align-items: center;
  letter-spacing: 0.1px;
  /* M3/sys/light/primary */
  color: var(--m3--sys--light--primary);
}
.other-photos-box .lightgallery-vue {
  flex-wrap: wrap;
}
.other-photos-box .lightgallery-vue > a {
  margin-bottom: 24px;
  width: 261px;
  margin-right: 20px;
  /* M3/read-only/light/white */
  background: #ffffff;
  /* M3/read-only/light/outline/opacity-0.16 */
  border: 1px solid var(--m3--read-only--light--outline--opacity-016);
  box-sizing: border-box;
  border-radius: 12px;
  overflow: hidden;
}

.other-photos-box .lightgallery-vue > a:nth-child(5n-1) {
  margin-right: 0px;
}

.other-photos-box .lightgallery-vue > a > span {
  padding: 16px;
  display: flex;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  letter-spacing: 0.5px;
  /* M3/read-only/light/black */
  color: var(--m3--read-only--light--black);
}

.other-photos-box .lightgallery-vue > a > img {
  width: 100%;
}

.first-product-item-text {
  padding: 16px;
  display: flex;
  /* M3/body/large */

  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  letter-spacing: 0.5px;

  /* M3/read-only/light/black */

  color: var(--m3--read-only--light--black);
}

.gallery-item.first-gallery {
  display: none;
}
.first-gallery.gallery-item:first-child {
  display: inherit !important;
}
.product-detail-first-image-box {
  background: #ffffff;
  border: 1px solid rgba(116, 119, 127, 0.16);
  box-sizing: border-box;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 32px;
  position: relative;
}
.product-detail-first-image-box > abbr {
  display: flex;
  align-items: center;
  position: absolute;
  right: 0;
  margin-right: 26px;
  margin-top: 22px;
}
.product-detail-first-image-box > abbr > span {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  /* M3/ref/primary/primary40 */
  color: var(--m3--ref--primary--primary40);
}

.product-detail-first-image-box > abbr > i {
  font-size: 24px;
  margin-right: 8px;
  /* M3/ref/primary/primary40 */
  color: var(--m3--ref--primary--primary40);
}

.product-detail-first-image-box .lightgallery-vue img {
  max-height: 544px;
  height: auto;
  cursor: pointer;
  margin: 0 auto;
  text-align: center;
  display: flex;
}

.back-to-company-details-box {
  margin-bottom: 17px;
}
</style>

<style >
.back-to-company-details-box > a {
  display: flex;
}
.back-to-company-details-box > a > span {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 28px;
  /* identical to box height, or 127% */
  display: flex;
  align-items: center;
  font-feature-settings: "liga" off;
  /* M3/sys/light/primary */
  color: var(--m3--sys--light--primary);
}

.back-to-company-details-box > a > i {
  font-size: 24px;
  color: var(--m3--sys--light--primary);
  margin-right: 10px;
}

.tag-box {
  margin-top: 78px;
}
.carousel {
  margin-bottom: 45px;
  margin-top: 32px;
}
.carousel__item {
  min-height: 200px;
  width: 100%;
  background-color: var(--m3--sys--light--background);
  color: rgb(0, 0, 0);
  font-size: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  margin-right: 10px;
  border: 1px solid var(--m3--read-only--light--outline--opacity-008);
  box-sizing: border-box;
  border-radius: 12px;
  overflow: hidden;
}
.carousel__item small {
  display: flex;
  white-space: pre;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  padding-top: 16px;
  padding-left: 16px;
  padding-bottom: 16px;
  color: var(--m3--sys--light--on-surface);
}
.carousel__item img {
  max-width: 200px;
  height: 124px;
}
.hr {
  height: 1px;
  margin: 32px 0;
  background-color: var(--m3--read-only--light--outline--opacity-016);
}
.membership-package-description {
  margin-top: 16px;
  flex-wrap: wrap;
  border-bottom: 1px solid rgba(116, 119, 127, 0.16);
  margin-bottom: 32px;
  padding-bottom: 26px;
}
.membership-package-description > a {
  /* M3/sys/light/on-primary */
  background: var(--m3--sys--light--on-primary);
  /* M3/read-only/light/outline/opacity-0.16 */
  border: 1px solid var(--m3--read-only--light--outline--opacity-016);
  box-sizing: border-box;
  border-radius: 8px;
  margin-right: 8px;
  padding: 6px 16px;
  display: flex;
  margin-bottom: 8px;
  justify-content: center;
}
.membership-package-description > a > span {
  /* M3/label/large */
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.1px;
  font-feature-settings: "liga" off;
  color: var(--m3--read-only--dark--black);
}
.membership-package-description > a > img {
  margin-right: 8px;
  width: 16px;
}
</style>


<style lang="postcss">
.did-floating-label-content {
  position: relative;
  min-width: 187px;
}
.did-floating-label {
  color: #1e4c82;
  font-size: 13px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 15px;
  top: 20px;
  padding: 0 5px;
  background: var(--m3--sys--light--on-primary);
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}
.did-floating-input,
.did-floating-select {
  font-size: 12px;
  display: block;
  width: 100%;
  height: 56px;
  padding: 0 20px;
  background: var(--m3--sys--light--on-primary);
  border-radius: 4px;
  box-sizing: border-box;

  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;
  letter-spacing: 0.5px;

  /* M3/sys/light/on-surface */
  color: var(--m3--sys--light--on-surface-variant);
}
.did-floating-input:focus,
.did-floating-select:focus {
  outline: none;
  box-shadow: none !important;
}
.did-floating-input:focus ~ .did-floating-label,
.did-floating-select:focus ~ .did-floating-label {
  top: -8px;
  font-size: 13px;
}
select.did-floating-select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
select.did-floating-select::-ms-expand {
  display: none;
}
.did-floating-input:not(:placeholder-shown) ~ .did-floating-label {
  top: -8px;
  font-size: 13px;
}
.did-floating-select:not([value=""]):valid ~ .did-floating-label {
  top: -8px;
  font-size: 13px;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  /* identical to box height, or 133% */
  letter-spacing: 0.5px;
  /* M3/sys/light/primary */
  color: var(--m3--sys--light--primary);
}
.did-floating-select[value=""]:focus ~ .did-floating-label {
  top: 20px;
  font-size: 13px;
}
.did-floating-select:not([multiple]):not([size]) {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='6' viewBox='0 0 8 6'%3E%3Cpath id='Path_1' data-name='Path 1' d='M371,294l4,6,4-6Z' transform='translate(-371 -294)' fill='%23003d71'/%3E%3C/svg%3E%0A");
  background-position: right 15px top 50%;
  background-repeat: no-repeat;
}

.input-group {
  display: flex;
}
.input-group .did-floating-input {
  border-radius: 0 4px 4px 0;
  border-left: 0;
  padding-left: 0;
}
.input-group-append {
  display: flex;
  align-items: center;
  /*   margin-left:-1px; */
}
.input-group-text {
  display: flex;
  align-items: center;
  font-weight: 400;
  height: 34px;
  padding: 0 5px 0 20px;
  font-size: 12px;
  text-align: center;
  white-space: nowrap;
  border-radius: 4px 0 0 4px;
  border-right: none;
}
option {
  /* M3/read-only/light/surface2 */
  background: var(--m3--read-only--light--surface2);
  /* M3/Elevation Light/2 */
  border-radius: 4px;
}

option:hover,
select:focus > option:checked {
  background: var(--m3--read-only--light--primary--opacity-012) !important;
  background-color: var(
    --m3--read-only--light--primary--opacity-012
  ) !important;
}

.visibility {
  visibility: hidden !important;
}

.mt-10p {
  margin-top: 10% !important;
}

.bg-trans {
  background: transparent !important;
}

.form-error {
  width: 100%;
  margin-bottom: 0.5rem;
  font-size: 0.875em;
  color: #dc3545;
}
.did-floating-label-content {
  padding-bottom: 0 !important;
}

.company-detail-form .form-control {
  font-size: 14px !important;
  color: black;
}

.zoom-btn {
  cursor: pointer;
}
</style>
